var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"booking-duration"},[_c('v-icon',{attrs:{"size":"16"}},[_vm._v("icon-Time")]),_c('span',{staticClass:"duration-string"},[_vm._v(_vm._s(_vm.durationString))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }